import React, { forwardRef, useImperativeHandle, useEffect } from "react";

import { useState } from "react";
import { verifyGST } from "../utils/gstInfoApi";
import InputLabel from "@mui/material/InputLabel";
import MinMaxFileUploader from "../utils/minmaxFileUploader";

import CustomButton from "../utils/Button";
import {
  Grid,
  FormControl,
  CircularProgress,
  TextField,
  FormControlLabel,
  Radio,
  FormLabel,
  RadioGroup,
} from "@mui/material";
import { Cross, VerifiedTick, ViewIcon } from "../assets/icons/index";
import Styles from "../../styles/clientForm.module.css";
import { statecityData } from "../../shared/enums";

import CustomInput from "../utils/Input";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import GlobalDropdownField from "../utils/GlobalDropdownField";
import capitalizeWords from "../../helperFunctions/capitalizedWords.js";

// import "../styles/ClientOnboarding.module.css"

const ClientOnboardingform = forwardRef(
  (
    {
      data,
      onChange,
      isEdit,
      // registerSubmit,
    },
    ref,
  ) => {
    const userId = localStorage.getItem("userId");
    const [formData, setFormData] = useState({
      userName: "",
      clientEmail: "",
      userRole: "",
      organizationName: "",
      state: "",
      city: "",
      gstin: "",
      pinCode: "",
      phoneNumber: "",
      address: "",
      sector: "",
      domain: "",
      addedBy: userId,
      clientAddress: "",
      associatedBrands: [],
      brandLogo: "",
      isClientOnBoarded: true,
      isOnBoarded: true,
      isVerified: false,
      userRoleId: "",
      isAnnualPartner: false,
    });

    const [isCustomSector, setIsCustomSector] = useState(false);
    const [customSectorInputRef, setCustomSectorInputRef] = useState(null);
    const [isCustomRole, setIsCustomRole] = useState(false);
    const [cityArray, setCityArray] = useState([]);

    const [errors, setErrors] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [submitloading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false); // loading state for API calls
    // const [isGstVerified, setIsGstVerified] = useState(false);
    const [isGstVerified, setIsGstVerified] = useState(
      data?.gstin?.length === 15,
    );

    const [saveButtonClicked, setSaveButtonClicked] = useState(false);
    const [openToast, setOpenToast] = React.useState(false);

    const cityApiKey = process.env.REACT_APP_FETCH_STATE_CITY_API_KEY;
    const serverURL = process.env.REACT_APP_URL;

    useEffect(() => {
      if (!data) return;

      const updated = {
        ...formData,

        userName: data.userName || data.name || "",
        clientEmail: data.clientEmail || data.emailAddress || "",
        phoneNumber: data.phoneNumber || "",
        userRoleId: data.userRoleId || "",
        clientAddress: data.clientAddress || "",
        associatedBrands: data.associatedBrands || [],

        organizationName: data.organizationName || data.name || "",
        gstin: data.gstin || "",
        state: data.state || "",
        city: data.city || "",
        pinCode: data.pinCode || data.zipCode || "",
        address: data.address || data.organizationAddress || "",
        sector: data.sector || "",
        domain: data.domain || "",
        brandLogo: data.brandLogo || "",
        isAnnualPartner: data?.isAnnualPartner,
      };

      updateFormData(updated);
    }, [data]);

    const updateFormData = (updated) => {
      setFormData(updated);

      if (onChange) {
        onChange(updated);
      }
    };

    useImperativeHandle(ref, () => ({
      validate: () => validateForm(),
    }));

    // Prevent mouse wheel from changing number inputs
    const handleWheel = (e) => {
      e.target.blur(); // Remove focus to prevent wheel scroll
    };

    // Add event listener on focus
    const handleFocus = (e) => {
      e.target.addEventListener("wheel", handleWheel, { passive: false });
    };
    const validateForm = () => {
      const newErrors = {};

      if (!isEdit) {
        if (!formData.userName) newErrors.userName = "Name is required";
        // if (!formData.userRole)
        //   newErrors.userRole = "Select Role In Organization";
        if (!formData.userRoleId) newErrors.userRoleId = "Enter User Role Id";
        if (!formData.clientAddress)
          newErrors.clientAddress = "Enter Client Address";
        if (!formData.phoneNumber || !/^\d{10}$/.test(formData.phoneNumber)) {
          newErrors.phoneNumber = "Valid Contact No is required";
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // General email pattern
        const restrictedDomains = ["gmail", "yahoo", "hotmail"]; // Domains you want to restrict

        const enteredEmail = formData.clientEmail || "";
        const enteredDomain = (formData.domain || "")
          .trim()
          .toLowerCase()
          .replace(/^https?:\/\//, "")
          .replace(/^www\./, "")
          .replace(/\/+$/, "");

        if (!enteredEmail || !emailPattern.test(enteredEmail)) {
          newErrors.clientEmail = "Enter a valid email address";
        } else {
          const emailDomain = enteredEmail.split("@")[1];

          if (
            restrictedDomains.some((restrictedDomain) =>
              emailDomain.startsWith(`${restrictedDomain}.`),
            )
          ) {
            newErrors.clientEmail = "Email from this domain is not allowed";
          } else if (!enteredDomain) {
            newErrors.domain = "Enter the domain";
          } else if (emailDomain !== enteredDomain) {
            newErrors.clientEmail =
              "Email domain must match the company domain";
          }
        }
      }

      if (!formData.pinCode || !/^\d{6}$/.test(formData.pinCode)) {
        newErrors.pinCode = "Valid Pin Code is required";
      }

      if (!formData.address) newErrors.address = "Address is required";

      if (!data?.organizationName) {
        if (!formData.organizationName)
          newErrors.organizationName = "Enter company name";
      }

      if (!formData.city) newErrors.city = "Enter City";
      if (!formData.state) newErrors.state = "Enter State";
      if (!formData.sector) newErrors.sector = "Enter Sector";

      if (!formData.gstin || formData.gstin.length < 15) {
        newErrors.gstin = "Enter the valid GSTIN ";
        setIsGstVerified(false);
      }

      if (!formData.domain) {
        newErrors.domain = "Enter the domain";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
    };
    // Focus on the custom input when it appears
    useEffect(() => {
      if (isCustomSector && customSectorInputRef) {
        customSectorInputRef.focus();
      }
    }, [isCustomSector, customSectorInputRef]);

    useEffect(() => {
      const stateCode = statecityData.find(
        (ele) => ele.name === formData.state,
      )?.iso2;

      if (formData.state) {
        const fetchCities = async (stateCode) => {
          const headers = new Headers();
          headers.append("X-CSCAPI-KEY", cityApiKey);

          const requestOptions = {
            method: "GET",
            headers: headers,
            redirect: "follow",
          };

          try {
            const response = await fetch(
              `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
              requestOptions,
            );

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const cityData = await response.json();
            setCityArray(cityData);
          } catch (error) {
            console.error("Error fetching cities:", error);
          }
        };

        fetchCities(stateCode);
      }
    }, [formData.state]);

    useEffect(() => {
      // registerSubmit(handleSubmit);
    }, []);

    const handleInputChange = (e) => {
      const { name, value } = e.target;

      // Sector
      if (name === "sector") {
        if (value === "OtherOption") {
          setIsCustomSector(true);

          const updated = {
            ...formData,
            sector: "",
          };

          updateFormData(updated);
          return;
        }

        setIsCustomSector(false);

        updateFormData({
          ...formData,
          sector: value,
        });

        return;
      }

      // Custom Sector
      if (name === "customSector" && isCustomSector) {
        updateFormData({
          ...formData,
          sector: value,
        });

        return;
      }

      // State Change
      if (name === "state") {
        updateFormData({
          ...formData,
          state: value,
          city: "",
        });

        setErrors((prev) => ({
          ...prev,
          city: "",
        }));

        return;
      }

      // GST
      if (name === "gstin") {
        setErrors((prev) => ({
          ...prev,
          gstin: "",
        }));

        setIsGstVerified(false);

        if (value.length === 15) {
          fetchDetailsThroughGSTIN(value.toUpperCase());
        }
      }

      // User Role
      if (name === "userRole" && value === "OtherOption") {
        setIsCustomRole(true);

        updateFormData({
          ...formData,
          userRole: "",
        });

        return;
      }

      if (name === "userRole" && isCustomRole) {
        updateFormData({
          ...formData,
          userRole: value,
        });

        return;
      }

      if (name === "userRole") {
        setIsCustomRole(false);

        updateFormData({
          ...formData,
          userRole: value,
        });

        return;
      }

      if (name === "isAnnualPartner") {
        updateFormData({
          ...formData,
          isAnnualPartner: value === "Yes",
        });

        return;
      }

      // Default
      let updatedValue = value;

      if (["address", "organizationName"].includes(name)) {
        updatedValue = capitalizeWords(value);
      }

      const updated = {
        ...formData,
        [name]: updatedValue,
      };

      updateFormData(updated);
    };

    const handleSubmit = async () => {
      setSubmitLoading(true);

      if (!validateForm()) {
        Swal.fire({
          customClass: { container: "my-swal" },
          icon: "error",
          text: "Please fill out the required fields correctly",
          color: "black",
        });

        setSubmitLoading(false);
        return false;
      }

      try {
        const token = localStorage.getItem("token");

        let response;

        if (data?._id) {
          // Update Organization
          response = await axios.put(
            `${serverURL}/organization/update/${data._id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
        } else {
          console.log(formData);
          // Create Organization
          response = await axios.post(
            `${serverURL}/organization/adds`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
            console.log(response),
          );
        }

        if (!response.data.success) {
          Swal.fire({
            customClass: { container: "my-swal" },
            icon: "error",
            text: response.data.error || "Operation Failed",
          });

          return false;
        }

        // ===== SUCCESS =====

        // if (selectedCompany?.organizationDetail?._id) {
        //   fetchUpdatedCompanyData();
        // } else {
        //   fetchCompanyData();
        // }

        Swal.fire({
          customClass: { container: "my-swal" },
          icon: "success",
          text: response.data.message,
          timer: 1500,
          showConfirmButton: false,
        });

        return true;
      } catch (error) {
        console.error(error);

        Swal.fire({
          customClass: { container: "my-swal" },
          icon: "error",
          text:
            error.response?.data?.error ||
            error.response?.data?.message ||
            "Something went wrong",
        });

        return false;
      } finally {
        setSubmitLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDetailsThroughGSTIN = async (gstNumber) => {
      setLoading(true);

      const responseData = await verifyGST(gstNumber);

      setLoading(false);

      if (responseData.error) {
        setErrors((prev) => ({
          ...prev,
          gstin: "Enter valid GSTIN",
        }));

        setIsGstVerified(false);

        return;
      }

      const updatedData = {
        ...formData,
        gstin: gstNumber,
        state: responseData?.taxpayerInfo?.pradr?.addr?.stcd || "",
        city: responseData?.taxpayerInfo?.pradr?.addr?.dst || "",
        organizationName:
          capitalizeWords(responseData?.taxpayerInfo?.tradeNam) || "",
        pinCode: responseData?.taxpayerInfo?.pradr?.addr?.pncd || "",
        address: capitalizeWords(
          [
            responseData?.taxpayerInfo?.pradr?.addr?.flno,
            responseData?.taxpayerInfo?.pradr?.addr?.bno,
            responseData?.taxpayerInfo?.pradr?.addr?.st,
            responseData?.taxpayerInfo?.pradr?.addr?.landMark,
            responseData?.taxpayerInfo?.pradr?.addr?.locality,
            responseData?.taxpayerInfo?.pradr?.addr?.loc,
          ]
            .filter(Boolean)
            .join(", "),
        ),
      };

      updateFormData(updatedData);

      setIsGstVerified(true);
    };

    return (
      <div>
        <div className="w-full">
          {" "}
          <form onSubmit={handleSubmit}>
            <div className={` ${Styles.formstyling}`}>
              {/* <Grid container spacing={2}> */}
              <h3 className="text-lg font-semibold text-[#101828] mb-6">
                Campany Details
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center items-start p-5">
                <Grid item xs={12} sm={6} md={4}>
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <CustomInput
                      className="text-xs font-medium leading-6 text-left"
                      placeholder="Enter Your GSTIN"
                      title="GSTIN*"
                      type="text"
                      size="small"
                      name="gstin"
                      error={errors.gstin}
                      errorMessage={
                        errors.gstin ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Enter the valid GSTIN
                          </span>
                        ) : null
                      }
                      value={formData?.gstin.toUpperCase()}
                      fontWeight="500"
                      onChange={(e) => {
                        if (
                          !e.target.value.startsWith(" ") && // Prevent leading space
                          e.target.value.length < 16 // Limit GSTIN input to 15 characters
                        ) {
                          handleInputChange(e); // Handle input change
                        }
                      }}
                    />

                    {/* Conditional Rendering of Loading, Error or Verified Icon */}
                    {loading ? (
                      <div className="absolute top-3/4 right-2 transform -translate-y-1/2 w-5 h-5 z-50 flex items-center justify-center">
                        <CircularProgress color="inherit" size={20} />
                      </div>
                    ) : errors.gstin ? (
                      <div className="absolute top-1/2 right-2 transform -translate-y-1/2 w-5 h-5 z-50 flex items-center justify-center">
                        <Cross
                          color="var(--error-color)"
                          fillcolor="var(--error-color)"
                        />
                      </div>
                    ) : isGstVerified ? (
                      <div className="absolute top-3/4 right-2.5 transform -translate-y-1/2 w-5 h-5 z-50 flex items-center justify-center">
                        <VerifiedTick
                          color="var(--third-color)"
                          fillcolor="var(--third-color)"
                        />
                        <p className="text-green-600 mr-5 text-2xl mb-2  rounded-full ">
                          ✔
                        </p>
                      </div>
                    ) : null}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="organizationName"
                    placeholder="Enter Company Name"
                    title="Company Name*"
                    value={formData?.organizationName}
                    size="small"
                    required
                    // value={formData?.vendorBusinessName}
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    errorMessage={
                      errors.organizationName ? (
                        <span style={{ color: "var(--error-color)" }}>
                          Please Enter Organization Name
                        </span>
                      ) : null
                    }
                    error={errors.organizationName}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  {isCustomSector ? (
                    <div className="relative">
                      <CustomInput
                        name="customSector"
                        placeholder="Specify your sector"
                        title="Sector*"
                        value={formData.sector}
                        size="small"
                        required
                        onChange={handleInputChange}
                        onBlur={(e) => {
                          if (saveButtonClicked) validateForm();
                        }}
                        errorMessage={errors.sector}
                        error={errors.sector}
                        inputRef={(ref) => setCustomSectorInputRef(ref)}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                              borderColor: "var(--primary-color)",
                              borderWidth: "2px",
                            },
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <GlobalDropdownField
                      name="sector"
                      label="Sector*"
                      value={formData.sector || ""}
                      onChange={handleInputChange}
                      placeholder="Industry Sector"
                      options={[
                        { value: "FMCG", label: "FMCG" },
                        { value: "Agricultural", label: "Agricultural" },
                        { value: "Automotive", label: "Automotive" },
                        {
                          value: "Banking & Finance",
                          label: "Banking & Finance",
                        },
                        {
                          value: "Hospitality & Travel",
                          label: "Hospitality & Travel",
                        },
                        {
                          value: "Entertainment & Media",
                          label: "Entertainment & Media",
                        },
                        { value: "Healthcare", label: "Healthcare" },
                        {
                          value: "Textile Industry",
                          label: "Textile Industry",
                        },
                        { value: "Energy", label: "Energy" },
                        {
                          value: "Tele Communication",
                          label: "Tele Communication",
                        },
                        { value: "OtherOption", label: "Other" }, // Add Other option
                      ]}
                      variant="sectorSelect"
                      error={errors.sector}
                      errorMessage={errors.sector}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return (
                            <p
                              style={{
                                color: "var(--light-gray)",
                                fontSize: "1rem",
                              }}
                            >
                              Industry Sector
                            </p>
                          );
                        }

                        // Show "Other" when OtherOption is selected
                        if (selected === "OtherOption") {
                          return "Other";
                        }

                        return selected;
                      }}
                    />
                  )}
                </Grid>

                {/* State Dropdown */}
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="state"
                    label="State*"
                    value={formData?.state || ""}
                    onChange={handleInputChange}
                    placeholder="Select State"
                    options={statecityData.map((state) => ({
                      value: state.name,
                      label: state.name,
                    }))}
                    variant="stateSelect"
                    error={errors.state}
                    errorMessage={errors.state}
                    renderValueFn={(selected) =>
                      !selected ? (
                        <p
                          style={{
                            color: "var(--light-gray)",
                            fontSize: "1rem",
                          }}
                        >
                          Select State
                        </p>
                      ) : (
                        selected
                      )
                    }
                  />
                </Grid>

                {/* City Dropdown */}
                <Grid item xs={12} sm={6} md={4}>
                  <GlobalDropdownField
                    name="city"
                    label="City*"
                    value={formData?.city || ""}
                    onChange={handleInputChange}
                    placeholder="City"
                    options={cityArray.map((c) => ({
                      value: c.name,
                      label: c.name,
                    }))}
                    variant="citySelect"
                    error={errors.city}
                    errorMessage={errors.city}
                    disabled={!formData.state}
                    renderValueFn={(selected) =>
                      !selected ? (
                        <p
                          style={{
                            color: "var(--light-gray)",
                            fontSize: "1rem",
                          }}
                        >
                          {formData.state
                            ? "Select City"
                            : "Select State First"}
                        </p>
                      ) : (
                        selected
                      )
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <CustomInput
                    name="pinCode"
                    placeholder="Enter Pin Code"
                    title="Pin Code*"
                    size="small"
                    type="number"
                    value={formData?.pinCode}
                    required
                    // value={formData?.vendorBusinessName}
                    onChange={(e) => {
                      if (
                        !e.target.value.startsWith(" ") &&
                        e.target.value.length < 7
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    onFocus={handleFocus}
                    onWheel={(e) => e.preventDefault()}
                    errorMessage={
                      errors.pinCode ? (
                        <span style={{ color: "var(--error-color)" }}>
                          Please Enter Pincode
                        </span>
                      ) : null
                    }
                    error={errors.pinCode}
                    InputProps={{
                      inputProps: {
                        min: 0,
                        onWheel: (e) => e.preventDefault(),
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <CustomInput
                    name="address"
                    placeholder="Address"
                    title="Organization Address*"
                    value={formData?.address}
                    size="small"
                    required
                    // value={formData?.vendorBusinessName}
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    errorMessage={
                      errors.address ? (
                        <span style={{ color: "var(--error-color)" }}>
                          Please Enter Organization Address
                        </span>
                      ) : null
                    }
                    error={errors.address}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <CustomInput
                    name="domain"
                    placeholder="Domain"
                    title="Organization Domain*"
                    value={formData?.domain}
                    size="small"
                    required
                    onChange={(e) => {
                      if (!e.target.value.startsWith(" ")) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={(e) => {
                      if (saveButtonClicked) {
                        validateForm();
                      }
                    }}
                    errorMessage={
                      errors.domain ? (
                        <span style={{ color: "var(--error-color)" }}>
                          Please Enter Organization Domain
                        </span>
                      ) : null
                    }
                    error={errors.domain}
                  />
                </Grid>
                <Grid item className="lg:col-span-1">
                  <FormControl>
                    <FormLabel
                      sx={{
                        fontSize: "16px",
                        fontWeight: 500,
                        mb: 1,
                        color: "black ",
                      }}
                    >
                      Annual Partner with Pixell
                    </FormLabel>

                    <RadioGroup
                      row
                      name="isAnnualPartner"
                      value={formData?.isAnnualPartner ? "Yes" : "No"}
                      onChange={handleInputChange}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#667085",
                              "&.Mui-checked": {
                                color: "#101828",
                              },
                            }}
                          />
                        }
                        label="Yes"
                      />

                      <FormControlLabel
                        value="No"
                        control={
                          <Radio
                            size="small"
                            sx={{
                              color: "#667085",
                              "&.Mui-checked": {
                                color: "#101828",
                              },
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                {/* </Grid> */}
              </div>
              <h3 className="text-lg font-semibold text-[#101828] mb-6">
                Brand Logo
              </h3>

              <div className="rounded-lg border border-dashed border-gray-300 bg-gray-50 p-5">
                <MinMaxFileUploader
                  initialFiles={formData.brandLogo}
                  onFilesUpload={(urls) => {
                    updateFormData({
                      ...formData,
                      brandLogo: urls,
                    });
                  }}
                  typeOfFilesAllowed="image/*"
                  maxFiles={1}
                />
              </div>
            </div>

            {!isEdit && (
              <div
                className={`flex flex-col justify-start  space-x-5 ${Styles.formstyling}`}
              >
                <h3 className="text-lg font-semibold text-[#101828] mb-6">
                  Representative Details
                </h3>
                <div className="grid grid-cols-1 gap-8 mt-2 ml-5 sm:grid-cols-2 lg:grid-cols-3">
                  <Grid item xs={12} sm={6}>
                    <CustomInput
                      name="userName" // Make sure the name matches the state property
                      placeholder="Enter Full Name"
                      title="Representative Name*"
                      size="small"
                      required
                      value={formData.userName} // Bind value to the state
                      onChange={(e) => {
                        const value = e.target.value;
                        const containsNumber = /\d/;
                        if (
                          !e.target.value.startsWith(" ") &&
                          !containsNumber.test(value)
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm(); // Perform validation if save button was clicked
                        }
                      }}
                      errorMessage={
                        errors.userName ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Your Name
                          </span>
                        ) : null
                      }
                      error={errors.userName} // Show error message if there is a validation error
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomInput
                      name="clientEmail" // Ensure the name matches the formData key (lowercase 'email')
                      placeholder="Enter Your Email"
                      title="Business Email*"
                      size="small"
                      required
                      value={formData.clientEmail}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.clientEmail ? (
                          <span style={{ color: "var(--error-color)" }}>
                            {errors.clientEmail}
                          </span>
                        ) : null
                      }
                      error={errors.clientEmail}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomInput
                      name="phoneNumber"
                      placeholder="Enter Your Phone Number"
                      title="Phone Number*"
                      size="small"
                      required
                      type="number"
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        if (
                          !e.target.value.startsWith(" ") &&
                          e.target.value.length <= 10
                        ) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      onFocus={handleFocus}
                      // onWheel={(e) => e.preventDefault()}
                      // onKeyPress={(e) => handleKeyPress(e)}
                      errorMessage={
                        errors.phoneNumber ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Enter Your Valid Phone Number
                          </span>
                        ) : null
                      }
                      error={errors.phoneNumber}
                      InputProps={{
                        inputProps: {
                          min: 0,
                          onWheel: (e) => e.preventDefault(),
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <div>
                      <GlobalDropdownField
                        name="userRoleId"
                        label="User Role*"
                        placeholder="Select Role"
                        value={formData?.userRoleId}
                        onChange={handleInputChange}
                        options={[
                          { value: 1, label: "Super Admin" },
                          // { value: 2, label: "Admin" },
                          // { value: 3, label: "Team Member" },
                        ]}
                        renderValueFn={(selected) => {
                          if (!selected) return "Select Role";
                          const roleMap = {
                            1: "Super Admin",
                            // 2: "Admin",
                            // 3: "Team Member",
                          };
                          return roleMap[selected] || "";
                        }}
                        // renderMenuItem={(opt) => (
                        //   <MenuItem key={opt.value} value={opt.value}>
                        //     {opt.label}
                        //   </MenuItem>
                        // )}
                        error={errors.userRoleId}
                        errorMessage={errors.userRoleId}
                        sx={{ marginTop: "0.5rem" }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} className="lg:col-span-2">
                    <CustomInput
                      name="clientAddress"
                      placeholder="Enter Address"
                      title="Representative Address*"
                      // value={clientAddress}
                      size="small"
                      required
                      value={formData?.clientAddress}
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                          // Clear the error when the user starts typing
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            clientAddress: "",
                          }));
                        }
                      }}
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.clientAddress ? (
                          <span style={{ color: "var(--error-color)" }}>
                            {errors.clientAddress === "Enter Client Address"
                              ? "Please Enter Address"
                              : "Representative Address is not correct"}
                          </span>
                        ) : null
                      }
                      error={errors.clientAddress}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} className="lg:col-span-3">
                    <CustomInput
                      name="associatedBrands"
                      placeholder="Enter Brand Names split by comma"
                      title="Associated Brands"
                      size="small"
                      required
                      onChange={(e) => {
                        if (!e.target.value.startsWith(" ")) {
                          handleInputChange(e);
                        }
                      }}
                      onBlur={(e) => {
                        if (saveButtonClicked) {
                          validateForm();
                        }
                      }}
                      errorMessage={
                        errors.associatedBrands ? (
                          <span style={{ color: "var(--error-color)" }}>
                            Please Enter Associated Brands
                          </span>
                        ) : null
                      }
                      error={errors.associatedBrands}
                    />
                  </Grid>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  },
);

export default ClientOnboardingform;
